"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cagnano-amiterno": {
    "a5720ddc": [{
      "hkey": "ef8aa821",
      "slug": "cagnano-amiterno",
      "name": "Cagnano Amiterno",
      "primary": true,
      "skipSearch": false
    }],
    "cascina": [{
      "hkey": "ef8aa821",
      "slug": "cagnano-amiterno",
      "name": "Cagnano Amiterno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "02316cb4": [{
      "hkey": "ef8aa821",
      "slug": "cagnano-amiterno",
      "name": "Cagnano Amiterno",
      "primary": true,
      "skipSearch": false
    }],
    "civitella": [{
      "hkey": "ef8aa821",
      "slug": "cagnano-amiterno",
      "name": "Cagnano Amiterno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1b2326b0": [{
      "hkey": "ef8aa821",
      "slug": "cagnano-amiterno",
      "name": "Cagnano Amiterno",
      "primary": true,
      "skipSearch": false
    }],
    "colle": [{
      "hkey": "ef8aa821",
      "slug": "cagnano-amiterno",
      "name": "Cagnano Amiterno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3d9d704c": [{
      "hkey": "ef8aa821",
      "slug": "cagnano-amiterno",
      "name": "Cagnano Amiterno",
      "primary": true,
      "skipSearch": false
    }],
    "collicello": [{
      "hkey": "ef8aa821",
      "slug": "cagnano-amiterno",
      "name": "Cagnano Amiterno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "783af43b": [{
      "hkey": "ef8aa821",
      "slug": "cagnano-amiterno",
      "name": "Cagnano Amiterno",
      "primary": true,
      "skipSearch": false
    }],
    "fossatillo": [{
      "hkey": "ef8aa821",
      "slug": "cagnano-amiterno",
      "name": "Cagnano Amiterno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0ae277ad": [{
      "hkey": "ef8aa821",
      "slug": "cagnano-amiterno",
      "name": "Cagnano Amiterno",
      "primary": true,
      "skipSearch": false
    }],
    "sala": [{
      "hkey": "ef8aa821",
      "slug": "cagnano-amiterno",
      "name": "Cagnano Amiterno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d40dd5fd": [{
      "hkey": "ef8aa821",
      "slug": "cagnano-amiterno",
      "name": "Cagnano Amiterno",
      "primary": true,
      "skipSearch": false
    }],
    "san-cosimo": [{
      "hkey": "ef8aa821",
      "slug": "cagnano-amiterno",
      "name": "Cagnano Amiterno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0739fbea": [{
      "hkey": "ef8aa821",
      "slug": "cagnano-amiterno",
      "name": "Cagnano Amiterno",
      "primary": true,
      "skipSearch": false
    }],
    "san-pelino": [{
      "hkey": "ef8aa821",
      "slug": "cagnano-amiterno",
      "name": "Cagnano Amiterno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fa18d57d": [{
      "hkey": "ef8aa821",
      "slug": "cagnano-amiterno",
      "name": "Cagnano Amiterno",
      "primary": true,
      "skipSearch": false
    }],
    "torre": [{
      "hkey": "ef8aa821",
      "slug": "cagnano-amiterno",
      "name": "Cagnano Amiterno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;